import React, { useEffect } from "react";
import { toast } from "react-toastify";
import { ConfirmationModalContext } from "../../../fautures/ConfirmationModalProvider";
import { useFetchWithToken } from "../../FetchWithToken/FetchWithToken";
import { AuthContext } from "../../../Constants/AuthProvider";
import { apiUrl } from "../../../Constants/Constants";
import BtnToAction from "./BtnToAction.module";
const Repair = ({ item, loadingShower, getInfo }) => {
  const { onLogout } = React.useContext(AuthContext);
  const { loading, fetchWithToken } = useFetchWithToken();
  useEffect(() => {
    loadingShower(loading);
  }, [loading]);
  const {
    openUpModal,
    description,
    confirmTitle,
    payloadConfirm,
    toDo,
    closeModal,
  } = React.useContext(ConfirmationModalContext);
  const troubleShootAccount = () => {
    confirmTitle("عیب یابی خودکار؟");
    openUpModal();

    description(
      <>
        بعد از تأیید، اکانت شما توسط سیستم بررسی و مشکلات احتمالی رفع می‌شود.
        این کار مخصوصاً وقتی همزمان با دو دستگاه وصل می‌شوید و اتصال‌تون دچار
        مشکل می‌شود، خیلی مفیده!
      </>
    );

    toDo(() => startTroubleShoot);
    payloadConfirm("");
  };
  const startTroubleShoot = () => {
    toast.info("در حال عیب یابی اکانت...");
    const former = new FormData();
    former.append("accountid", item.id);

    fetchWithToken(
      apiUrl + "user/troubleshoot",
      { method: "POST" },
      former
    ).then((data) => {
      closeModal();
      if (data.status === "200") {
        toast.success(data.data);

        getInfo();
      } else if (data.status === "6") {
        toast.error(data.data);
      }
      if (data.status === "401") {
        onLogout();
      }
    });
  };
  return (
    <BtnToAction icon="fal fa-user-doctor" action={() => troubleShootAccount()}>
      عیب یابی
    </BtnToAction>
  );
};

export default Repair;
